import { Salad, Flower2, Sparkles, Star, Leaf } from 'lucide-react';

// EU Organic "Euro-leaf" official logo image
export const EU_BIO_LOGO_URL = "https://static.prod-images.emergentagent.com/jobs/6671443e-c6ab-40d7-8beb-3e990709eae4/images/539fde6640eb69425e4461d8d8ec4fc96a225e7829c9e7bab39ff37bb6433d41.png";

export const EuroLeafImg = ({ size = 28 }) => (
    <img src={EU_BIO_LOGO_URL} alt="EU Organic" width={size} height={size * 0.67} className="rounded-sm inline-block" style={{ objectFit: 'contain' }} />
);

// Image du marché de Rungis
export const RUNGIS_IMAGE = "https://static.prod-images.emergentagent.com/jobs/99864558-9e93-4687-9902-98a919d206dc/images/09aeab283548deb646a7dbe08f52b5f508170135bf9864277a3b528ace6fe3e8.png";

// Normalize category ID
export const normCat = (id) => {
    if (id === 'cat-plants') return 'cat-plantes';
    return id;
};

export const CATEGORY_IMAGES = {
    'cat-fruits': 'https://static.prod-images.emergentagent.com/jobs/b6a29314-2818-4117-815f-ff9f4e3b6960/images/1bb9af9c195d74e27808797fbe6fede6d02622bf58d72865303bafa750aeed3f.png',
    'cat-legumes': 'https://customer-assets.emergentagent.com/job_b6a29314-2818-4117-815f-ff9f4e3b6960/artifacts/i4u2b5zc_image.png',
    'cat-plantes': 'https://static.prod-images.emergentagent.com/jobs/42df5828-da38-47df-a4a0-6876150d3b0a/images/e1e761c3ba7c58aa6d775c5bee89e69b7417612da8cd180ec339807436976c71.png',
    'cat-african': 'https://static.prod-images.emergentagent.com/jobs/b6a29314-2818-4117-815f-ff9f4e3b6960/images/4e51c09fb73da52bc684a356d9013965b5f61837af432815158bd74adebad98a.png',
    'cat-cosmetics': 'https://images.unsplash.com/photo-1763503836825-97f5450d155a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwxfHxuYXR1cmFsJTIwYmVhdXR5JTIwc2tpbmNhcmUlMjBjcmVhbSUyMGphcnxlbnwwfHx8fDE3NzM4MzgyNTN8MA&ixlib=rb-4.1.0&q=85',
    'cat-bio': 'https://static.prod-images.emergentagent.com/jobs/459738c3-5601-4e6f-b959-ddc2c1be106f/images/0414cfeed3c90b2e34da2792113730a1895657e54d775a45ad05c7eb2e5943e1.png',
};

export const CATEGORY_ICONS = {
    'cat-fruits': '🍎',
    'cat-legumes': '🥬',
    'cat-plantes': '🌿',
    'cat-african': '🌍',
    'cat-cosmetics': '✨',
    'cat-bio': '🌱',
};

export const CATEGORY_COLORS = {
    'cat-fruits': '#EF4444',
    'cat-legumes': '#16A34A',
    'cat-plantes': '#10B981',
    'cat-african': '#D97706',
    'cat-cosmetics': '#A855F7',
    'cat-bio': '#4CAF50',
};

export const MONTHS = ['Jan', 'Fév', 'Mar', 'Avr', 'Mai', 'Juin', 'Juil', 'Août', 'Sep', 'Oct', 'Nov', 'Déc'];
export const MONTHS_FULL = ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'];

export const formatSeason = (start, end) => {
    if (!start || !end) return null;
    return `${MONTHS[start - 1]} à ${MONTHS[end - 1]}`;
};

export const CATEGORY_META = {
    'cat-fruits': { icon: Salad, label: 'Fruits', color: 'red', bg: 'bg-red-100', text: 'text-red-700' },
    'cat-legumes': { icon: Salad, label: 'Légumes', color: 'emerald', bg: 'bg-emerald-100', text: 'text-emerald-700' },
    'cat-plantes': { icon: Flower2, label: 'Plantes & Fleurs', color: 'pink', bg: 'bg-pink-100', text: 'text-pink-700' },
    'cat-african': { icon: Sparkles, label: 'Alimentaire Africain', color: 'amber', bg: 'bg-amber-100', text: 'text-amber-700' },
    'cat-cosmetics': { icon: Star, label: 'Cosmétique', color: 'purple', bg: 'bg-purple-100', text: 'text-purple-700' },
    'cat-bio': { icon: Leaf, label: 'Bio', color: 'lime', bg: 'bg-lime-100', text: 'text-lime-700' },
};

export const CAROUSEL_COLORS = {
    'red': { btn: 'bg-red-600 hover:bg-red-700', badge: 'bg-red-600', accent: 'text-red-600', border: 'hover:border-red-500 hover:bg-red-50' },
    'emerald': { btn: 'bg-emerald-600 hover:bg-emerald-700', badge: 'bg-emerald-600', accent: 'text-emerald-600', border: 'hover:border-emerald-500 hover:bg-emerald-50' },
    'pink': { btn: 'bg-pink-600 hover:bg-pink-700', badge: 'bg-pink-600', accent: 'text-pink-600', border: 'hover:border-pink-500 hover:bg-pink-50' },
    'amber': { btn: 'bg-amber-600 hover:bg-amber-700', badge: 'bg-amber-600', accent: 'text-amber-600', border: 'hover:border-amber-500 hover:bg-amber-50' },
    'purple': { btn: 'bg-purple-600 hover:bg-purple-700', badge: 'bg-purple-600', accent: 'text-purple-600', border: 'hover:border-purple-500 hover:bg-purple-50' },
    'lime': { btn: 'bg-lime-600 hover:bg-lime-700', badge: 'bg-lime-600', accent: 'text-lime-600', border: 'hover:border-lime-500 hover:bg-lime-50' },
};

// Weather code to description + icon
export const weatherDesc = (code) => {
    if (code === 0) return { text: 'Ensoleillé', icon: '☀️' };
    if (code <= 3) return { text: 'Nuageux', icon: '⛅' };
    if (code <= 48) return { text: 'Brouillard', icon: '🌫️' };
    if (code <= 57) return { text: 'Bruine', icon: '🌦️' };
    if (code <= 67) return { text: 'Pluie', icon: '🌧️' };
    if (code <= 77) return { text: 'Neige', icon: '🌨️' };
    if (code <= 82) return { text: 'Averses', icon: '🌧️' };
    if (code <= 86) return { text: 'Neige', icon: '🌨️' };
    if (code <= 99) return { text: 'Orage', icon: '⛈️' };
    return { text: '', icon: '🌤️' };
};
